import VideoCard from "./VideoCard";
import QuizCard from "./QuizCard";
import HeaderOperations from "./HeaderOperations";

function ItemsContainer({ lectureItems }) {
    // Check if there is any item of type "video"
    const hasVideo = lectureItems?.data?.some(
        (item) => item.attributes.type === "video"
    );
    const hasQuiz = lectureItems?.data?.some(
        (item) => item.attributes.type === "quiz"
    );

    return (
        <>
            <HeaderOperations lectureItems={lectureItems} />
            {/* Videos Section */}
            {!hasQuiz && !hasVideo && (
                <p className="mt-10 text-lg font-semibold text-center text-gray-color-primary">
                    لا يوجد فيديوهات ولا إختبارات
                </p>
            )}
            <div>
                {/* Title for Videos Section */}
                {hasVideo && (
                    <div className="flex items-center justify-start gap-3 pt-6 border-t-2">
                        <p className="text-2xl font-bold text-blue-color-primary">
                            الفيديوهات
                        </p>
                    </div>
                )}
                {/* Videos Cards */}
                <div className="flex flex-wrap items-center justify-center gap-4 py-8 lg:justify-start">
                    {lectureItems?.data?.map((item, index) => {
                        if (item.attributes.type === "video") {
                            return <VideoCard videoItem={item} key={index} />;
                        }
                        return null;
                    })}
                </div>
            </div>

            {/* Quizzes Section */}
            <div>
                {/* Title for Quizzes Section */}

                {hasQuiz && (
                    <div className="flex items-center justify-start gap-3 pt-6 border-t-2">
                        <p className="py-6 text-2xl font-bold text-blue-color-primary">
                            الأختبارات
                        </p>
                    </div>
                )}

                {/* Quizzes Cards */}
                <div className="flex flex-wrap items-center justify-center gap-4 py-8 lg:justify-start">
                    {lectureItems?.data?.map((item, index) => {
                        if (item.attributes.type === "quiz") {
                            return <QuizCard quizItem={item} key={index} />;
                        }
                        return null;
                    })}
                </div>
            </div>
        </>
    );
}

export default ItemsContainer;
